<template>
  <div class="menu-nav-view border-bottom-1px">
    <div class="menu-list" ref="menuWrapper">
      <ul class="menu-list-ul ui-rows-m" ref="menuListUl">
        <!-- v-yunji-report="{parent:'category-level-three',name:'search-ul-list',key:index,includeChild:'*',data:'tab-1-'+(index+1)+'--'+item.categoryLevelName}" -->
        <li v-for="(item,index) in menuData" :key="index" :class="{'active':index == clickIndex}" class="menu-li-hook" @click="selectedSortLabel($event,index,item)" :ref="item.categoryLevelName + index">{{item.categoryLevelName}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapActions } = createNamespacedHelpers('brandList')
import BScroll from 'better-scroll';
import { InfiniteScroll,Spinner } from 'mint-ui';
import { Promise } from 'q';
Vue.use(InfiniteScroll);
export default {
  data() {
    return {
      clickIndex: 0,
      menuScroll: '', // 菜单栏-滚动BScroll
    }
  },
  computed: {
    ...mapState({
      menuData: state => state.menuData
    }),
    categoryId: {
      get: function() {
        return this.$store.state.brandList.categoryId
      },
      set: function(val) {
        this.$store.commit('brandList/SETCATEGORYID', val)
      }
    }
  },
  created() {
    const categoryId = this.$route.query.categoryId
    if (categoryId) this.categoryId = categoryId
    this.init()
  },
  methods: {
    ...mapActions(['queryBrandMenu', 'queryBrandList']),
    async init() {
      const res = await this.queryBrandMenu()
      this.$nextTick(() => {
        this._initMenuScroll()
        this.initSlide()
        this.calcCheckedMenu()
      })
    },
    // 计算被选中的菜单
    calcCheckedMenu() {
      if (this.menuData.length == 0) return
      for (let i = 0; i< this.menuData.length; i++) {
        if(this.menuData[i].categoryLevelId == this.categoryId) {
          this.clickIndex = i
          break;
        }
      }
      // 获取选中的节点计算滚动位置
      const index = this.clickIndex
      const name = this.menuData[index].categoryLevelName
      const str = name + index
      this.calcSroll(this.$refs[str][0], index)
    },
    // 计算菜单栏可滚动长度
    _initMenuScroll(){
      let children = this.$refs.menuListUl.children;
      let width = 0, marginRight=0;
      for (let i = 0; i < children.length; i++) {
        let item = children[i];
        width += item.offsetWidth;
        marginRight += parseFloat(document.defaultView.getComputedStyle(item).marginRight.split("px")[0]);
      }
      this.$refs.menuListUl.style.width = width + marginRight + 10 + 'px'; //获取全部总长度
    },
    // 空间初始化
    initSlide() {
      if(!this.menuScroll && this.$refs.menuWrapper){
        this.menuScroll = new BScroll(this.$refs.menuWrapper, {
          scrollX: true,
          scrollY: false,
          click: true
        });
      }else{
        this.menuScroll.refresh();
      }
    },
    selectedSortLabel(event,index,{categoryLevelId, categoryLevelName}) {
      this.clickIndex = index;
      this.calcSroll(event.target, index)
      if (categoryLevelId != this.categoryId) {
        this.categoryId = categoryLevelId
        // 获取对应的品牌列表
        this.queryBrandList()
      }
    },
    // 计算滚动位置
    calcSroll(data, index) {
      const currScroll = this.menuScroll
      const liLen = this.menuData.length - 1
      let preNode = null;
      if(index > 0){
        // previousSibling获取前一个兄弟节点
        preNode = data.previousSibling;
      }
      if(index < 3){
        // 前面3个不用滑动
        currScroll.scrollTo(0,0);
      } else if (liLen - index < 3) {
        const scrollLeft = currScroll.maxScrollX; //IScroll最大的滚动位置，滚动到底部
        currScroll.scrollTo(scrollLeft,0);
      } else {
        // 获取当前元素的前面2个元素
        currScroll.scrollToElement(preNode);
      }
    },
  }
};
</script>

<style lang="less" scoped>
.menu-nav-view{
  display: flex;
  width: 100%;
  height: 1rem;
  flex-shrink: 0;
  background-color: #fff;
  .menu-list{
    position: relative;
    box-sizing: border-box;
    width: 90%;
    height: 1rem;
    margin: 0 0.32rem;
    overflow: hidden;
    white-space: nowrap;
    .menu-list-ul{
      height: 1rem;
      .menu-li-hook{
        margin-right: 0.5rem;
        font-size: 0.28rem;
        height: 0.88rem;
        line-height: 0.88rem;
        color: #505050;
        flex: 0 0 auto;
        &:last-of-type{
          margin-right: 0;
        }
        &.active{
          color: #f10d3b;
          border-bottom: 3px solid #f10d3b;
        }
      }
    }
  }
}
</style>